import {Component, ElementRef, forwardRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {
  UserSubscription,
  UserSubscriptionIds,
  UserSubscriptionType
} from "../../../user/user-subscription";
import {User} from "../../../user/user";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";

@Component({
    selector: 'db-plan-period-switch',
    templateUrl: './plan-period-switch.component.html',
    styleUrls: ['./plan-period-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PlanPeriodSwitchComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class PlanPeriodSwitchComponent implements OnInit, OnChanges {

  @Input() currentSubscription: UserSubscription;
  @Input() isEcommerceWebsite: boolean;
  @Input() formControl: FormControl;
  @Input() dontChangeSwitchValue?: boolean;
  @Input() size: ''|'sm';
  @Input() user: User;
  @Input() limitedTimeOffer: boolean = false;
  @Input() disabled: boolean = false;
  @Input() switcherColor?: string = 'blue';
  @Input() small?: boolean = false;
  @Input() boosterPro?: boolean;
  @Input() hideBadge?: boolean;
  @Input() uppercaseTitle?: boolean = true;
  @Input() newPrice?: boolean = false;
  @Input() isMobile?: boolean = false;
  @Input() forDemo?: boolean = false;
  public toggled: boolean = true;

  protected readonly userSubscriptionStatus = UserSubscriptionStatus;

  public switch: FormControl;
  public UserSubscriptionType = UserSubscriptionType;
  public userSubscriptionIds: any = UserSubscriptionIds;
  private _propagateChange: Function = (_: any) => {};

  constructor(
    private elementRef: ElementRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disabled'] && changes['disabled'].currentValue) {
      this.switch && this.switch.disable();
    }
  }

  ngOnInit(): void {
    /*TODO Lilith change to 12 always*/

    const switchValue: number = (this.small || this.dontChangeSwitchValue) ? this.formControl.value : this.currentSubscription.type === 'starter' ? 12 : ( this.currentSubscription.type !== 'platform' ? 1 : this.currentSubscription.plan.periodNumber);
    if (this.small || this.dontChangeSwitchValue) {
      this.toggled = switchValue === 1;
    }
    else {
      if (this.currentSubscription.type === 'starter') {
        this.toggled = false;
      }
    }

    this.switch = new FormControl(switchValue);
    if (this.disabled || (switchValue === 12 && this.user.connectedFromProductId !== 91 && (this.currentSubscription.type !== 'starter'
      && ((!this.currentSubscription.boosterProClient
        || (this.currentSubscription.boosterProClient
          && this.currentSubscription.plan.periodNumber === 12)) || this.currentSubscription.plan.periodNumber === 12)))) {
      this.switch && this.switch.disable();
    }
  //  this.onSwitch();
    if (this.toggled) {
      this.toggled = this.currentSubscription.plan.periodNumber === 1 || this.currentSubscription.plan.periodNumber === 6 ? true : false;
    }
    this.formControl.valueChanges.subscribe((val: any) => {
      this.formControl.setValue(val, {emitEvent: false});
      this.updateSwitch();
    });
  }

  private updateSwitch(): void {
    this.toggled = this.formControl.value !== 12;
    this.switch.setValue(this.formControl.value);
  }

  writeValue(value: any): void {}

  registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {}

  public onSwitch(): void {
    this.toggled = !this.toggled;
    if (this.elementRef.nativeElement.querySelector('.db-switch__input').classList.contains('db-monthly')) {
      this.switch.setValue(1);
    }
    else if (this.elementRef.nativeElement.querySelector('.db-switch__input').classList.contains('db-yearly')) {
      this.switch.setValue(12);
    }

    this._propagateChange(this.switch.value);
  }

}
